import { Controller } from 'react-hook-form';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@zep/ui/experimental';
import { OperationType } from '../../../../../../types';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../../PlanPaymentSection/Providers';
import { OnetimePeriod } from '../../../types';
import { useConvertOnetimePeriodToText } from '../../../utils/useConvertOnetimePeriodToText';
const CUSTOM_ONETIME_PERIODS: OnetimePeriod[] = ['1M', '2M', '3M', '4M', '5M', '6M', '7M', '8M', '9M', '10M', '11M', '12M'] as const;
export const CustomOnetimeMonthSelect = () => {
  const {
    control,
    getValues
  } = usePlanPaymentFormContext();
  const {
    currentOperationType
  } = usePlanPaymentInfoContext();
  const {
    convertOnetimePeriodToText
  } = useConvertOnetimePeriodToText();
  return <Controller control={control} name="onetimePeriod" defaultValue={getValues('onetimePeriod')} render={({
    field
  }) => {
    return <Select onValueChange={field.onChange} defaultValue={field.value} disabled={currentOperationType === OperationType.일시납}>
            <SelectTrigger className="h-[34px] w-[120px] text-body-2 font-medium">
              <SelectValue placeholder={'플랜 시작일'} />
            </SelectTrigger>
            <SelectContent className="max-h-[196px] w-[120px]">
              <SelectGroup>
                {CUSTOM_ONETIME_PERIODS.map(period => <SelectItem value={period} key={period}>
                    {convertOnetimePeriodToText(period)}
                  </SelectItem>)}
              </SelectGroup>
            </SelectContent>
          </Select>;
  }} data-sentry-element="Controller" data-sentry-component="CustomOnetimeMonthSelect" data-sentry-source-file="CustomOnetimeMonthSelect.tsx" />;
};